<template>
  <!-- // 招聘数据看板 -->
  <div class="recruitmentData">
    <div>
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="showData">
      <span style="font-size: 20px; float: right; font-weight: bold">
        {{ $route.query.name }}
      </span>
      <div class="day_ele">
        <div class="title">数据</div>
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        tab-position="left"
        v-loading="load"
        element-loading-text="加载中..."
      >
        <el-tab-pane label="日报" name="day">
          <el-row type="flex" class="space-between" justify="">
            <el-col :span="4" v-for="(item, i) in data.slice(0, 5)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="space-between" justify="">
            <el-col :span="4" v-for="(item, i) in data.slice(5, 11)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row></el-tab-pane
        >
        <el-tab-pane label="周报" name="week">
          <el-row type="flex" class="space-between" justify="">
            <el-col :span="4" v-for="(item, i) in data.slice(0, 5)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="space-between" justify="">
            <el-col :span="4" v-for="(item, i) in data.slice(5, 11)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="月报" name="month">
          <el-row type="flex" class="space-between">
            <el-col :span="4" v-for="(item, i) in data.slice(0, 5)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="space-between">
            <el-col :span="4" v-for="(item, i) in data.slice(5, 11)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="至今" name="all">
          <el-row type="flex" class="space-between">
            <el-col :span="4" v-for="(item, i) in data.slice(0, 5)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
          <el-row type="flex" class="space-between">
            <el-col :span="4" v-for="(item, i) in data.slice(5, 11)" :key="i"
              ><div
                :class="
                  keyIndex == item.field
                    ? 'grid-content keyIndex'
                    : 'grid-content'
                "
                @click="keyIndexChange(item.field)"
              >
                <p>{{ item.text }}</p>
                <p>{{ item.value }}</p>
              </div></el-col
            >
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div class="day_ele">
        <div class="title">详情</div>
        <Index
          :activeName="activeName"
          v-if="keyIndex == 'user_login_count'"
        ></Index>
        <!-- <produceJdQr
          v-if="
            ['produce_jd_qr_count', 'official_account_qr_count'].indexOf(
              keyIndex
            ) > -1
          "
          :activeName="activeName"
          :show_data="str_qr"
        ></produceJdQr> -->
        <jdConent
          v-if="
            [
              'jd_count',
              'jd_browse_count',
              'chat_count',
              'produce_jd_qr_count',
              'official_account_qr_count',
              'interview_count',
            ].indexOf(keyIndex) > -1
          "
          :activeName="activeName"
          :show_data="str_qr"
        ></jdConent>
        <resumeLaiyuan
          v-if="
            [
              'clue_count',
              'download_resume_count',
              'send_resume_count',
            ].indexOf(keyIndex) > -1
          "
          :activeName="activeName"
          :show_data="str_qr"
        ></resumeLaiyuan>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import Index from "@/components/recruitmentData/index";
import produceJdQr from "@/components/recruitmentData/produce_jd_qr";
import jdConent from "@/components/recruitmentData/jdConent";
import resumeLaiyuan from "@/components/recruitmentData/resumeLaiyuan";

export default {
  name: "recruitmentData",
  //组件引入
  components: { Index, produceJdQr, jdConent, resumeLaiyuan },
  //状态存储
  data() {
    return {
      activeName: "day",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = Math.round(new Date() / 1000);
              const start = Math.round(new Date() / 1000) - 86400 * 7;
              console.log(end, "最近一周");
              picker.$emit("pick", [start * 1000, end * 1000]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = Math.round(new Date() / 1000);
              const start = Math.round(new Date() / 1000) - 86400 * 30;
              picker.$emit("pick", [start * 1000, end * 1000]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = Math.round(new Date() / 1000);
              const start = Math.round(new Date() / 1000) - 86400 * 90;
              picker.$emit("pick", [start * 1000, end * 1000]);
            },
          },
        ],
      },
      time: [
        (Math.round(new Date() / 1000) - 86400 * 7) * 1000,
        Math.round(new Date() / 1000) * 1000,
      ],
      keyIndex: "user_login_count",
      data: [
        {
          field: "user_login_count",
          value: '加载中...', //登录次数
          text: "登录次数",
          show_data: "login",
        },
        {
          field: "jd_count",
          value: '加载中...', //职位总量
          text: "JD设置",
          show_data: "jd_list",
        },
        {
          field: "jd_browse_count",
          value: '加载中...', //职位浏览量
          text: "JD浏览量",
          show_data: "jd_browse",
        },
        {
          field: "chat_count",
          value: '加载中...', //在线沟通量
          text: "在线沟通量",
          show_data: "chat_list",
        },
        {
          field: "produce_jd_qr_count",
          value: '加载中...', //海报生成次数
          text: "分享海报",
          show_data: "produce_jd_qr",
        },
        {
          field: "official_account_qr_count",
          value: '加载中...', //手机端生成公众号
          text: "公众号/视频号推广",
          show_data: "official_account_qr",
        },
        {
          value: '加载中...', //简历雷达总数
          text: "简历雷达总数",
          field: "clue_count",
          show_data: "radar_status",
        },
        {
          value: '加载中...', //下载简历数
          text: "猎场简历下载",
          field: "download_resume_count",
          show_data: "liechang_status",
        },
        {
          value: '加载中...', //投递简历量
          text: "我的简历总数",
          field: "send_resume_count",
          show_data: "resume_management",
        },
        {
          value: '加载中...', //面试数
          text: "面试人数",
          field: "interview_count",
          show_data: "interview_list",
        },
      ],
      liechang_status_data: { 未标记: 1726 }, //猎场简历状态
      management_status_data: { 未处理: 11 }, //简历管理简历状态
      radar_status_data: { 不合格: 5, 未标记: 125 }, //简历雷达状态
      source_net_data: { "": 11 }, //简历来源
      str_qr: "",
      load: true,
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {},
  //存放方法集合
  methods: {
    keyIndexChange(val) {
      this.keyIndex = "";
      this.$nextTick(() => {
        this.data.map((item) => {
          if (item.field == val) {
            this.str_qr = item.show_data;
          }
        });
        this.keyIndex = val;
      });
    },
    timeChange(data) {
      console.log(data);
      this.user_data_info(this.$route.query.id, data[0] / 1000, data[1] / 1000);
    },
    handleClick(val) {
      console.log("active", val);
      this.data.map((item)=>{
        item.value = '加载中...'
      })
      if (this.activeName != val) {
        this.user_data_info(this.$route.query.id);
      }
      this.load = true;
    },
    //简历分布
    resumeCount() {
      console.log("resumeCount", this.$refs.resumeCount);
      this.$echarts.init(this.$refs.resumeCount).setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          data: ["简历雷达", "简历主动下载", "投递简历"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.date,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "简历雷达",
            type: "line",
            // stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: this.clue_count,
          },
          {
            name: "简历主动下载",
            type: "line",
            // stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: this.download_resume_count,
          },
          {
            name: "投递简历",
            type: "line",
            // stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: this.send_resume_count,
          },
        ],
      });
    },
    resumeBrowse() {
      console.log("resumeBrowse", this.$refs.resumeBrowse);
      this.$echarts.init(this.$refs.resumeBrowse).setOption({
        // title: {
        //   text: "简历总浏览量",
        //   //   left: "center",
        // },
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#FFA500", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "blue", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },

        tooltip: {},
        xAxis: {
          type: "category",
          // boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#000", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
          data: this.date,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#000", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
        },
        series: [
          {
            name: "获得浏览量",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { label: { show: true } } },
            backgroundStyle: {
              color: "rgb(50, 199, 245)",
            },
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: this.jd_browse_count,
          },
        ],
      });
    },
    chatCount() {
      console.log("chatCount", this.$refs.chatCount);
      this.$echarts.init(this.$refs.chatCount).setOption({
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#FFA500", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "blue", // 100% 处的颜色
            },
          ],
          global: false, // 缺省为 false
        },

        tooltip: {},
        xAxis: {
          type: "category",
          // boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#000", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
          data: this.date,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#000", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
        },
        series: [
          {
            name: "在线沟通量",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { label: { show: true } } },
            backgroundStyle: {
              color: "rgb(50, 199, 245)",
            },
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: this.chat_count,
          },
        ],
      });
    },
    user_data_info(user_detail_id) {
      // day, week, month, all
      let obj = {
        user_detail_id: this.$route.query.id,
        day_week: this.activeName,
      };
      require("POST", "/hr24_index_data/v1/user_data_info/", obj).then(
        (res) => {
          if (!res.code) {
            let data = res.data[0];
            this.data.map((item) => {
              for (let key in data) {
                if (key == item.field) {
                  item.value = data[item.field];
                }
              }
              return item;
            });
            this.load = false;
          }
          console.log("res", res);
        }
      );
      require("POST", "/hr24_index_data/v1/resume_data_info/", obj).then(
        (res) => {
          if (!res.code) {
            let data = res.data[0];
            this.data.map((item) => {
              for (let key in data) {
                if (key == item.field) {
                  item.value = data[item.field];
                }
              }
              return item;
            });
          }
          console.log("res", res);
        }
      );
      require("POST", "/hr24_index_data/v1/promotion_info/", obj).then(
        (res) => {
          if (!res.code) {
            let data = res.data[0];
            this.data.map((item) => {
              for (let key in data) {
                if (key == item.field) {
                  item.value = data[item.field];
                }
              }
              return item;
            });
          }
          console.log("res", res);
        }
      );
    },
  },
  //数据初始化之后
  created() {
    const start = new Date();
    this.user_data_info(this.$route.query.id);
  },
  //页面渲染之后
  mounted() {},
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */

.recruitmentData {
  position: relative;
  top: 80px;
  left: 200px;
  width: calc(100% - 220px);
  /* background: rgb(253, 88, 88); */
  min-height: 80vh;
  margin-bottom: 50px;
  /* background: #fff; */
}
.showData {
  padding: 20px;
  background: #fff;
  margin-top: 20px;
}
.day_ele {
  padding: 0px 20px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  padding: 0 0 12px 0px;
  border-bottom: #dfdfdf solid 2px;
}
.grid-content {
  text-align: center;
  cursor: pointer;
}
.grid-content:hover .btn,
.keyIndex {
  color: #3e84e9;
  font-weight: bold;
}

.btn {
  font-size: 12px;
  cursor: pointer;
  color: #7eaff5;
}
.Details > p {
  padding: 20px 20px;
  font-size: 20px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/agentManagement/recruitmentData.vue